import { render, staticRenderFns } from "./GolfParkMember.vue?vue&type=template&id=82da6876&scoped=true"
import script from "./GolfParkMember.vue?vue&type=script&lang=js"
export * from "./GolfParkMember.vue?vue&type=script&lang=js"
import style0 from "./GolfParkMember.vue?vue&type=style&index=0&id=82da6876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da6876",
  null
  
)

export default component.exports